// extracted by mini-css-extract-plugin
export default {"MoveModal":"MoveModal_MoveModal__Yi7z1","MoveModal__text":"MoveModal_MoveModal__text__bEdPO","MoveModal__notification":"MoveModal_MoveModal__notification__YcM7o"};